import React from "react";
import { Login } from "../../components/Login/Signup";

function SignIn() {
  return <Login />;
}

export default SignIn;
